import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { FeedbackInbox } from '../shared/FeedbackInbox';
import BaseLayout from './BaseLayout';
import DashboardIcon from '@mui/icons-material/Dashboard';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import AssignmentIcon from '@mui/icons-material/Assignment';
import PeopleIcon from '@mui/icons-material/People';
import BarChartIcon from '@mui/icons-material/BarChart';
import SettingsIcon from '@mui/icons-material/Settings';

// Import lesson components
import { CreateLesson } from '../teacher/CreateLesson';
import { ManageUnits } from '../teacher/ManageUnits';
import { LessonsList } from '../teacher/LessonsList';
import { ViewLesson } from '../../pages/ViewLesson';
import { EditUnitContentPage } from '../../pages/teacher/EditUnitContent';
import MyStudents from '../teacher/MyStudents';
import { Assignments } from '../teacher/Assignments';
import { StudentProgress } from '../teacher/StudentProgress';
import { TeacherSettings } from '../teacher/TeacherSettings';

// Placeholder components for other teacher routes
const TeacherDashboard = () => <div>Teacher Dashboard - Coming Soon</div>;

/**
 * TeacherLayout component for teachers
 * Provides navigation and routes for lesson creation and student management
 */
const TeacherLayout: React.FC = () => {
  const navigationItems = [
    { label: 'Review Feedback', path: '/teacher/feedback', icon: <AssignmentIcon /> },
    {
      label: 'Dashboard',
      path: '/teacher/dashboard',
      icon: <DashboardIcon />,
    },
    {
      label: 'My Lessons',
      path: '/teacher/lessons',
      icon: <MenuBookIcon />,
    },
    {
      label: 'Create Lesson',
      path: '/teacher/create-lesson',
      icon: <AddCircleIcon />,
    },
    {
      label: 'Assignments',
      path: '/teacher/assignments',
      icon: <AssignmentIcon />,
    },
    {
      label: 'My Students',
      path: '/teacher/students',
      icon: <PeopleIcon />,
    },
    {
      label: 'Progress',
      path: '/teacher/progress',
      icon: <BarChartIcon />,
    },
    {
      label: 'Settings',
      path: '/teacher/settings',
      icon: <SettingsIcon />,
    },
  ];

  return (
    <BaseLayout title="Teacher Portal" navigationItems={navigationItems}>
      <Routes>
        <Route path="feedback" element={<FeedbackInbox teacher />} />
        <Route path="dashboard" element={<TeacherDashboard />} />
        <Route path="lessons" element={<LessonsList />} />
        <Route path="lessons/create" element={<CreateLesson />} />
        <Route path="lessons/:moduleId/units" element={<ManageUnits />} />
        <Route path="lessons/:moduleId/units/:unitId/edit" element={<EditUnitContentPage />} />
        <Route path="lessons/:moduleId/view" element={<ViewLesson />} />
        <Route path="create-lesson" element={<CreateLesson />} />
        <Route path="assignments" element={<Assignments />} />
        <Route path="students" element={<MyStudents />} />
        <Route path="progress" element={<StudentProgress />} />
        <Route path="settings" element={<TeacherSettings />} />
        <Route path="/" element={<Navigate to="/teacher/dashboard" replace />} />
        <Route path="*" element={<Navigate to="/teacher/dashboard" replace />} />
      </Routes>
    </BaseLayout>
  );
};

export default TeacherLayout;
